import type * as TSentry from "@sentry/react";
import { getHost } from "@src/env";
import { useEffect } from "react";
import {
  createBrowserRouter,
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from "react-router";

export function setupSentry(Sentry: typeof TSentry) {
  Sentry.init({
    dsn: "https://8be559c93559d09d04fc83bfd7859bed@o4508846131970048.ingest.us.sentry.io/4508846134001664",
    ignoreErrors: [
      /AbortError/, // The play() request was interrupted by a call to pause()
      /NotAllowedError/, // play() failed because the user didn't interact with the document first
      /Unexpected token/, // Third-party APIs sometimes returns non-JSON data
      /Failed to fetch/, // Internet connection is down
      /Failed to update a ServiceWorker/,
      /Track ID offline is already being used/,
      /Track ID offline does not exist/,
      /NetworkError/,
      /Service Worker is not supported in this browser/,
      /Cannot resume a context that has been closed/,
      /HTMLOUT/, // wishkidsclub de Recife (navegador da TV)
      /Failed to start the audio device/, // iOS com Safari antigo (economize)
      /^Non-Error promise rejection captured with value: Object Not Found Matching Id:\d+/, // canopybyhilton
      /The document is in an invalid state/, // Race condition (Electron)
      /Bad gateway/i, // [registerRadioSession] Erro ao processar a resposta da API. JSON inválido: Cloudflare 502 Bad gateway
      /Error code 520/i, // [registerRadioSession] Erro ao processar a resposta da API. JSON inválido: Cloudflare 520 Web server is returning an unknown error
      /A timeout occurred/, // [registerRadioSession] Erro ao processar a resposta da API. JSON inválido: Cloudflare 524 A timeout occurred
      /registerRadioSession/, // [registerRadioSession] Erro ao processar a resposta da API. JSON inválido:
      /Java object is gone/, // Instagram/Facebook WebView "postMessage" race condition (https://github.com/facebook/react/issues/34053)
      /Large HTTP payload/, // Radio.co
    ],
    integrations: [
      Sentry.reactRouterV7BrowserTracingIntegration({
        useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
      Sentry.eventFiltersIntegration(),
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        maskAllInputs: false,
      }),
      Sentry.consoleLoggingIntegration({ levels: ["log", "warn", "error"] }),
    ],

    // Tracing
    tracesSampleRate: 1.0, // Capture 100% of the transactions

    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: ["localhost", getHost()],

    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.

    // Enable logs to be sent to Sentry
    enableLogs: true,
  });
  return Sentry.wrapCreateBrowserRouterV7(createBrowserRouter);
}
